export const colors = {
  theme: {
    light: {
      body: '#FAFAFA',
      bodySecondary: 'white',
      primary: '#343036',
      secondary: '#1A181B',
      tertiary: '#2aabe2',
    },
    dark: {
      body: '#1A181B',
      primary: '#343036',
      secondary: '#1A181B',
      tertiary: '#2aabe2',
    },
  },

  button: {
    primary: {
      500: '#2aabe2',
    },
  },

  text: {
    light: {
      primary: '#282829',
      secondary: '#2aabe2',
      tertiary: 'white',
      divider: '#292b3a',
    },
    dark: {
      primary: '#3C3C3C',
      secondary: '#B186FC',
    },
  },
};
